const mapPageSpecificationUrls = ['/atlas/dashboard', '/kavi/dashboard'];
const isIncludeUrl = (url) => mapPageSpecificationUrls.includes(url);
export { mapPageSpecificationUrls, isIncludeUrl };
